import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/eligibilitySummaryCard.module.scss';

function EiligibilitySummaryContent({ title, value, icon }) {
    return (
        <div className={styles.kpiRow}>
            <div className={styles.kpiLabelGroup}>
                <span className={styles.kpiIcon}>{icon}</span>
                <Text as="span" size="xs" className={styles.kpiLabel}>
                    {title}
                </Text>
            </div>
            <Text as="span" size="xs" className={styles.kpiValue}>
                {value}
            </Text>
        </div>
    );
}
export default EiligibilitySummaryContent;